export default "__VITE_ASSET__8a224e01__"